module.exports = "<p>\n  algorithm works!\n</p>\n"